export default {
  buttons: {
    back: "Zpět",
    next: "Další",
  },
};
